export default "/kiban/_next/static/images/login_image_1-74e828093519c4c78ccabd7f63f70beb.jpg";